var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoading) ? _c('section', {
    staticClass: "role"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('b', [_vm._v("Logged Single Dispute")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.Backinvestigation
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("ShippingID:")]), _vm._v(" "), _c('b-input-group', [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "shippingid",
      "name": "shippingid",
      "disabled": ""
    },
    model: {
      value: (_vm.shippingid),
      callback: function($$v) {
        _vm.shippingid = $$v
      },
      expression: "shippingid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Shipment Type:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "shipmentType",
      "options": _vm.shipmentTypeList,
      "placeholder": "Select Type",
      "label": "label",
      "track-by": "label",
      "disabled": true
    },
    model: {
      value: (_vm.shipmentType),
      callback: function($$v) {
        _vm.shipmentType = $$v
      },
      expression: "shipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Dispute Reason :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), (_vm.loadingDisputeReasons) ? _c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }) : _vm._e(), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "disputeReason",
      "options": _vm.disputeReasonList,
      "placeholder": "Select dispute reason",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.onDisputeReasonChange
    },
    model: {
      value: (_vm.disputeReason),
      callback: function($$v) {
        _vm.disputeReason = $$v
      },
      expression: "disputeReason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('disputeReason')),
      expression: "errors.has('disputeReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("dispute reason is required. ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Dispute SubReason :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "name": "disputeSubReason",
      "options": _vm.subReasonList,
      "placeholder": "Select dispute reason",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.onDisputeSubReasonChange
    },
    model: {
      value: (_vm.disputeSubReason),
      callback: function($$v) {
        _vm.disputeSubReason = $$v
      },
      expression: "disputeSubReason"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('disputeReason')),
      expression: "errors.has('disputeReason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("dispute reason is required. ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("DisputeAmount:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "disputeAmount",
      "name": "disputeAmount",
      "type": "disputeAmount"
    },
    model: {
      value: (_vm.disputeAmount),
      callback: function($$v) {
        _vm.disputeAmount = $$v
      },
      expression: "disputeAmount"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Description :")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "name": "description",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(74, 17, 179)",
      "font-size": "13px"
    }
  }, [_vm._v("\n                  Description should be at least 20 characters.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [
    [_c('div', [_c('div', [_c('label', {
      staticClass: "section-label"
    }, [_vm._v("Upload package photos "), (_vm.isimage === true) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), [_c('div', {
      staticClass: "image-grid-wrapper"
    }, [(_vm.isLoading1) ? _c('div', {
      staticClass: "upload-popup"
    }, [_c('div', {
      staticClass: "popup-content"
    }, [_c('div', {
      staticClass: "loader-spinner"
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loaderMessage))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "image-grid"
    }, _vm._l((_vm.imagePositions), function(position, index) {
      return _c('div', {
        key: index,
        staticClass: "image-upload-box"
      }, [(_vm.uploadedImages[position.key]) ? _c('div', {
        staticClass: "image-preview"
      }, [_c('img', {
        attrs: {
          "src": _vm.uploadedImages[position.key],
          "alt": "preview"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "remove-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.removeImage(position.key)
          }
        }
      }, [_vm._v("✖")])]) : _c('div', {
        staticClass: "upload-placeholder",
        on: {
          "click": function($event) {
            _vm.triggerImageInput(position.key)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-upload upload-icon"
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(position.label))])]), _vm._v(" "), _c('input', {
        ref: 'imageInput_' + position.key,
        refInFor: true,
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "file",
          "accept": "image/*",
          "ref-in-for": ""
        },
        on: {
          "change": function($event) {
            _vm.handleImageUpload($event, position.key)
          }
        }
      })])
    }))])]], 2), _vm._v(" "), _c('label', {
      staticClass: "section-label"
    }, [_vm._v("\n                    Upload Video\n                    "), (_vm.isvideo === true) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "video-row"
    }, _vm._l((_vm.videoTypes), function(video) {
      return _c('div', {
        key: video.key,
        staticClass: "video-column"
      }, [_c('p', {
        staticClass: "sub-label"
      }, [_vm._v(_vm._s(video.label))]), _vm._v(" "), _c('div', {
        staticClass: "video-upload-box"
      }, [(_vm.uploadedVideo[video.key]) ? _c('div', {
        staticClass: "video-preview"
      }, [_c('video', {
        key: _vm.uploadedVideo[video.key],
        attrs: {
          "controls": "",
          "playsinline": ""
        }
      }, [_c('source', {
        attrs: {
          "src": _vm.uploadedVideo[video.key],
          "type": "video/mp4"
        }
      }), _vm._v("\n                            Your browser does not support the video tag.\n                          ")]), _vm._v(" "), _c('span', {
        staticClass: "remove-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.removeVideo(video.key)
          }
        }
      }, [_vm._v("✖")])]) : _c('div', {
        staticClass: "upload-placeholder",
        on: {
          "click": function($event) {
            _vm.triggerVideoInput(video.key)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-upload upload-icon"
      }), _vm._v(" "), _c('span', [_vm._v("Upload " + _vm._s(video.label))]), _vm._v(" "), _c('input', {
        ref: ("videoInput_" + (video.key)),
        refInFor: true,
        attrs: {
          "type": "file",
          "accept": "video/*",
          "hidden": ""
        },
        on: {
          "change": function($event) {
            _vm.handleVideoUpload($event, video.key)
          }
        }
      })])])])
    }))])]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("OtherProof-1:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "OtherProof1",
      "name": "OtherProof1",
      "type": "OtherProof1"
    },
    model: {
      value: (_vm.OtherProof1),
      callback: function($$v) {
        _vm.OtherProof1 = $$v
      },
      expression: "OtherProof1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("OtherProof-2:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-book'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "OtherProof2",
      "name": "OtherProof2",
      "type": "OtherProof2"
    },
    model: {
      value: (_vm.OtherProof2),
      callback: function($$v) {
        _vm.OtherProof2 = $$v
      },
      expression: "OtherProof2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [(!_vm.isFormValid && _vm.actionstatuscode === '38') ? _c('button', {
    staticClass: "btn btn-sm btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveData()
      }
    }
  }, [_vm._v("Save as Draft")]) : _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveData()
      }
    }
  }, [_vm._v("Submit "), _c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.Backinvestigation()
      }
    }
  }, [_vm._v("\n                Cancel "), _c('i', {
    staticClass: "fa fa-times"
  })])])])])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1) : _c('vue-element-loading', {
    attrs: {
      "active": true,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a786d8b8","hasScoped":true}!./src/views/components/EditSingleDispute/EditSingleDispute.component.html
// module id = 689
// module chunks = 1